import { format, parse } from 'date-fns';

// Funksjon for å tolke datoformat manuelt
export const parseCustomDateString = (dateString) => {
    if (!dateString) return null;

    try {
        // Hvis dateString allerede er en ISO-streng, returner et Date-objekt direkte
        const parsedDate = new Date(dateString);

        if (!isNaN(parsedDate.getTime())) {
            return parsedDate;
        }

        // Hvis det ikke er en gyldig Date, forsøk å parse det som "d.M.yyyy, HH:mm:ss"
        return parse(dateString, 'd.M.yyyy, HH:mm:ss', new Date());
    } catch (error) {
        console.error('Feil ved parsing av dato:', dateString, error);
        return null;
    }
};

// Hovedfunksjon for å formatere datoen riktig
export const formatDateTime = (dateString) => {
    if (!dateString) return 'Ukjent dato';

    const parsedDate = parseCustomDateString(dateString);

    return parsedDate ? format(parsedDate, 'dd.MM.yyyy HH:mm') : 'Ugyldig dato';
};

export default formatDateTime;
